import { css } from 'styled-components';
import { StyledTheme } from '../../../../styles';

export const SelectInputDateStyles = css<{ theme: StyledTheme }>`
  position: relative;

  select > option {
    color: ${({ theme }) => theme.palette.primaryHoverTextColor};
  }

  label {
    color: ${({ theme }) => theme.palette.waldoPrimary};
    font-family: ${({ theme }) => theme.typography.mainFontFamily};
  }

  select {
    text-align: center;
    transition: all 0.2s ease-in-out 0s;
    font-family: ${({ theme }) => theme.typography.mainFontFamily};
    color: ${({ theme }) => theme.palette.waldoPrimary};
    background-color: ${({ theme }) => theme.palette.primary.rgba('0')};
    border: none;
    padding: 0.2rem 0.75rem;
    border: none;
    outline: none;
    appearance: none;
    -webkit-appearance: none;
    cursor: pointer;
    font-size: ${({ theme }) => theme.sizing.fontS}rem;

    &::placeholder {
      color: ${({ theme }) => theme.palette.waldoPrimary};
      opacity: 50%;
    }

    &:hover,
    &:focus {
      color: ${({ theme }) => theme.palette.waldoPrimary};
    }
  }
`;
